import React from "react";
import * as c from "./lcBreadcrumbs.module.scss";
import { Link } from "gatsby";
import classNames from "classnames";
import ArrowIcon from "@icons/arrowIcon";

export default function LcBreadcrumbs({
  className,
  sectionTitle,
  sectionSlug,
  categoryTitle,
  categorySlug,
  subcategoryTitle,
  subcategorySlug,
}) {
  let links = [
    {
      title: "Home",
      slug: "",
    },
    {
      title: sectionTitle,
      slug: sectionSlug,
    },
  ];

  if (categoryTitle && categorySlug) {
    links.push({
      title: categoryTitle,
      slug: categorySlug,
    });

    if (subcategoryTitle && subcategorySlug) {
      links.push({
        title: subcategoryTitle,
        slug: subcategorySlug,
      });
    }
  }

  let currentPath = "/learn";
  let linkEls = [];
  links.forEach((link, idx) => {
    let linkElement = [];
    currentPath += link.slug + "/";

    if (idx !== 0) {
      linkElement.push(
        <span key={`${link.slug}--separator`}>
          <ArrowIcon className={classNames(c.caret)} direction="right" />
        </span>
      );
    }

    if (link.slug === "help-articles" || link.slug === "getting-started") {
      return;
    }

    linkElement.push(
      <Link className={c.link} key={`${link.slug}--href`} to={currentPath}>
        {link.title}
      </Link>
    );

    linkEls.push(
      <div className={c.linkContainer} key={`${link.slug}--container`}>
        {linkElement}
      </div>
    );
  });

  return <div className={classNames(c.container, className)}>{linkEls.length > 1 && linkEls}</div>;
}
